import { render } from "./GerenciamentoUsuarios.vue?vue&type=template&id=640170e8&scoped=true"
import script from "./GerenciamentoUsuarios.vue?vue&type=script&lang=js"
export * from "./GerenciamentoUsuarios.vue?vue&type=script&lang=js"

import "./GerenciamentoUsuarios.vue?vue&type=style&index=0&id=640170e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640170e8"]])

export default __exports__